import { useTranslation } from "react-i18next";
import { Dropdown, Form, Input, Segment } from "semantic-ui-react";
import { PromotionCampaignStatusLabel, STATUS_ARRAY } from "../CampaignStatus/CampaignStatus";
import { useCallback, useState } from "react";

export const PromotionCampaignFilters = ({ currentFilters, onFilterChange, isLoading }) => {
    const { t } = useTranslation();

      const [status, setStatus] = useState(Array.isArray(currentFilters?.status) ? currentFilters.status : ["DRAFT",'ENABLED',]);
      const [search, setSearch] = useState(currentFilters?.search || '');

     const handleFilterChange = useCallback((filter) => {
          if (filter.status !== undefined) {
            setStatus(Array.isArray(filter.status) ? filter.status : []);
          }
          if (filter.search !== undefined) {
            setSearch(filter.search);
          }
          onFilterChange({
            ...(filter.status !== undefined && { status: Array.isArray(filter.status) ? filter.status : [] }),
            ...(filter.search !== undefined && { search: filter.search }),
          });
    }, [onFilterChange]);

    return (
          <Segment>
          <Form>
            <Form.Group widths="equal">
            <Form.Field>
              <label>Status</label>
              <Dropdown
                loading={isLoading}
                placeholder="Status"
                selection
                multiple
                clearable
                renderLabel={(label,index,defaultLabelsProps) => (<PromotionCampaignStatusLabel status={label.value} {...defaultLabelsProps} {...label} />)}
                options={STATUS_ARRAY.map(o => ({...o, value:o.key, text:t(`promotion_campaign.status.${o.key}`, o.key), label:{...o.label, circular:true,empty:true}}))}
                value={status}
                onChange={(e, { value }) => handleFilterChange({ status: value })}
        />
            </Form.Field>
            <Form.Field>
              <label>Recherche</label>
              <Input
                loading={isLoading}
              
                placeholder="Recherche..."
                value={search}
                onChange={e => handleFilterChange({search: e.target.value || null}) }
              />
            </Form.Field>
          </Form.Group>
        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }} className="filters-bar">
      </div>
      </Form>
        </Segment>
    )
}